module.exports = __webpack_public_path__ + "static/12-1-8cc28f895fb3d856e579ce6ab7585380.jpg";